import { TimeModalProvider } from '../contexts/TimeModalContext';
import styles from './Default.module.scss';
import { MenuProvider } from '../contexts/MenuContext';

function DefaultLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className={styles.defaultLayout}>
      <TimeModalProvider>
        <MenuProvider>{children}</MenuProvider>
      </TimeModalProvider>
    </div>
  );
}

export default DefaultLayout;
